import { Event } from "../../../types";
import SectionHeading from "@/components/SectionHeading";
import { renderContent } from "@/lib/htmlContentHelpers";
import "@/lib/htmlContent.css";

interface EventContentSectionsProps {
  event: Event;
}

export function EventContentSections({ event }: EventContentSectionsProps) {
  return (
    <>
      <div className="border-0 border-sys-brand-secondary-container pb-12">
        <SectionHeading heading="Event Description" />
        <div className="text-body-large break-words text-sys-brand-on-surface">
          {renderContent(event.description, { enhancedCleanup: true })}
        </div>
      </div>
    </>
  );
}
